const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

const dataToolkitFindings = (jobs = [], { actions = {}, now = Date.now() } = {}) => {
  const list = Array.isArray(jobs) ? jobs : [];
  const out = [];
  const failed = list.filter(j => String(j.status).toUpperCase() === "FAILED");
  if (failed.length) {
    out.push({ tone: "bad", key: "failed", label: `${failed.length} failed job${failed.length === 1 ? "" : "s"}`, text: "Credits were reserved but nothing was enriched. Retry.", actions: actions.retry ? [{ label: "Retry", run: () => actions.retry(failed[0]) }] : [] });
  }
  const running = list.filter(j => ["RUNNING", "IN_PROGRESS", "QUEUED"].includes(String(j.status).toUpperCase()));
  if (running.length) {
    out.push({ tone: "neutral", key: "running", label: `${running.length} job${running.length === 1 ? "" : "s"} running`, text: "I will not start another enrichment until these finish." });
  }
  const done = list.filter(j => {
    if (String(j.status).toUpperCase() !== "PROCESSED") return false;
    if (!j.createTs) return false;
    const created = new Date(j.createTs).getTime();
    return !Number.isNaN(created) && now - created <= WEEK_MS;
  });
  const found = done.reduce((a, j) => a + (Number(j.counts?.found) || 0), 0);
  if (found > 0) {
    out.push({ tone: "hot", key: "post_enrich", label: `${found} contacts now have emails`, text: "Enriched but idle. Put them in a sequence.", actions: actions.addToSequence ? [{ label: "Add to sequence", run: actions.addToSequence }] : [] });
  }
  const lowYield = done
    .map(j => {
      const input = Number(j.inputRowCount) || 0;
      const got = Number(j.counts?.found) || 0;
      return { j, rate: input ? got / input : 0, input, got };
    })
    .filter(({ rate, input, j }) => j.creditsCharged > 0 && input >= 20 && rate < 0.3)
    .sort((a, b) => a.rate - b.rate);
  if (lowYield.length) {
    const worst = lowYield[0];
    const more = lowYield.length - 1;
    out.push({
      tone: "warn",
      key: "low_yield",
      label: `${worst.j.name || "Job"} found ${Math.round(worst.rate * 100)}%`,
      text: `Low hit rate for the credits spent. Check the input list before running more.${more ? ` (and ${more} more job${more === 1 ? "" : "s"} under 30%)` : ""}`
    });
  }
  return out;
};

export default dataToolkitFindings;
